import React, { Component } from 'react'
import Line from '../Line'
import { translation, enumtranslate } from '../../../../utils/helpers'

class OtherDamageLine extends Component {
  render () {
    const damage = this.props.damage
    if (!damage) return null

    let damageName
    if (damage.Type === 10) {
      damageName = damage.CustomName
    } else {
      damageName = translation(enumtranslate('OtherDamageTypes', damage.Type))
    }

    return (
      <Line text={damageName} onDelete={this.props.onDelete.bind(this, this.props.damage)} />
    )
  }
}

export default OtherDamageLine



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/OtherDamageLine/index.js